export const CUSTOM_FIELD_TYPE_OPTIONS = [
  { value: "text", label: "Text" },
  { value: "rich_text", label: "Rich text" },
  { value: "number", label: "Number" },
  { value: "date", label: "Date" },
  { value: "boolean", label: "Yes/No" },
  { value: "single_select", label: "Single select" },
  { value: "multi_select", label: "Multi select" },
  { value: "cross_reference", label: "Relationships" },
  { value: "user_reference", label: "User reference" },
  { value: "url", label: "URL" },
] as const

export const FORMAT_OPTIONS = [
  { value: "plain", label: "Number" },
  { value: "currency", label: "Currency" },
  { value: "percentage", label: "Percentage" },
] as const

export const CURRENCY_OPTIONS = [
  { value: "USD", label: "US Dollar (USD)" },
  { value: "EUR", label: "Euro (EUR)" },
  { value: "AUD", label: "Australian Dollar (AUD)" },
  { value: "CAD", label: "Canadian Dollar (CAD)" },
] as const

export const DEFAULT_CURRENCY_CODE = "USD" as const

export const CROSS_REFERENCE_TARGET_OPTIONS = [
  { value: "Household", label: "Household / Client / Prospect" },
  { value: "Contact", label: "Contact" },
  { value: "Person", label: "Person" },
  { value: "Business", label: "Business" },
  { value: "User", label: "User" },
] as const

export const DEFAULT_ENTITY_TYPE_OPTIONS = [
  { value: "Household", label: "Household" },
  { value: "Person", label: "Person" },
  { value: "Contact", label: "Contact" },
  { value: "Business", label: "Business" },
  { value: "Opportunity", label: "Opportunity" },
  { value: "InsurancePolicy", label: "Insurance policy" },
  { value: "FinancialAccount", label: "Manual financial account" },
  { value: "Trust", label: "Trust" },
] as const

export const FIELD_TYPE_LABELS: Record<string, string> = CUSTOM_FIELD_TYPE_OPTIONS.reduce(
  (acc, option) => {
    acc[option.value] = option.label
    return acc
  },
  {} as Record<string, string>
)

FIELD_TYPE_LABELS.user_reference = "User reference"

export function getEntityTypeLabel(entityType: string) {
  const option = [...DEFAULT_ENTITY_TYPE_OPTIONS].find((item) => item.value === entityType)
  return option ? option.label : entityType
}
